import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// services
import { LoginService } from '../../../shared/services/login.service';
import { CopyService } from '../../../shared/services/app-copy.service';
import { ErrorHandler } from "../../../shared/services/error-handler.service";
// models
import { AppState } from '../../../booking/models/app-state.interface';
// globals
import { EMAIL_PATTERN } from '../../../shared/globals';

@Component({
  selector: 'app-login-options',
  templateUrl: './login-options.component.html',
  styleUrls: ['./login-options.component.scss']
})
export class LoginOptionsComponent implements OnInit, OnDestroy {

  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _resetPasswordsubscription: Subscription;
  private _userSubscription: Subscription;

  public emailPattern = EMAIL_PATTERN;
  public showEmailLoader: Boolean = false;
  public userEmail;
  public userNotFound: Boolean = false;
  public showLoader: Boolean = false;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';
  public showPasswordOption = false;

  public showEmailSent: Boolean = false;
  public passwordAvailable = false;
  public showLoginOptions = false;

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _router: Router,
    private _copyService: CopyService,
    private _errorHandler: ErrorHandler,
  ) { }

  ngOnInit() {
    this._userLanguageSubscription = this._appStore.select('copyReducer')
      .subscribe((res: any) => {
        this.selectedLanguage = res.language
      })

    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        this.copyLoaded = res.copyLoaded;
        if (res.copyLoaded) {
          this.getCopy();
        }

      })

    this._userSubscription = this._appStore.select('userReducer')
      .subscribe((user: any) => {
        if (user.userDetails.userEmail === '') {
          this._router.navigate(['login']);
        }

        this.showPasswordOption = user.userDetails.userHasPassword;
        this.userEmail = user.userDetails.userEmail;

      });

    this._resetPasswordsubscription = this._loginService.forgotPasswordEmailSent$
      .subscribe(emailSent => {

        if (emailSent.error) {
          this.showLoader = false;
          return;
        }

        if (emailSent) {
          const data = {
            text: "OTP sent to Email!",
            type: "info",
          };

          if (this.getState(this._appStore).userReducer.userDetails.is2FARequired) {
            data.text = 'OTP sent to phone number!';
          }

          this._errorHandler.handleCustomInfo(data);


        }

        this.showLoader = false;
        this._router.navigate(['access-account-otp'], { queryParams: { emailSent: emailSent } });

      },
        err => console.log(err));

  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'login',
      ['loginScreen']
    );
    console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  goToPassword(e) {
    e.preventDefault();
    this._router.navigate(['access-account']);

  }

  sendOTP(e) {
    e.preventDefault();
    this.showLoader = true;

    this._loginService.sendOTP(this.userEmail);
  }

  getState(store: Store<AppState>) {
    let state: AppState;
    store.subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    this._resetPasswordsubscription.unsubscribe();
    this._userLanguageSubscription.unsubscribe();
    this._bookingInitSubscription.unsubscribe();
    this._userSubscription.unsubscribe();
  }
}
